<script lang="ts" setup>
import { computed } from "vue";
import { useDisplay } from "vuetify";
import { useLayoutStore } from "@/store/app";
import { LAYOUTS } from "@/app/const";
import VerticalNavDrawer from "@/components/layouts/leftSideBar/verticalLayout/index.vue";

const { xs } = useDisplay();
const state = useLayoutStore();

const { VERTICAL } = LAYOUTS;

const isVertical = computed(() => {
  return state.layoutType === VERTICAL;
});

</script>
<template>
  <VerticalNavDrawer v-if="isVertical || xs" />
</template>
